import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import Address from "~/models/Address";

const DisplayAddress = observer(({ address }) => {
  return (
    <>
      {address.street}
      {address.street2 && `, ${address.street2}`}
      {address.city && `, ${address.city}`}
      {address.state && ` ${address.state}`}
      {address.zip && ` ${address.zip}`}
      {address.country && `, ${address.country}`}
    </>
  );
});

DisplayAddress.propTypes = {
  address: PropTypes.instanceOf(Address),
};

export default DisplayAddress;
